import { schemes, zSchema } from "@zeal/common";

const zContributionPatch = zSchema.object({
  value: zSchema.number(),
  contribution_type: zSchema
    .enum(["cents", "dollars", "percentage"])
    .optional(),
});

export const patchContractorPaymentDeductionRequestSchema = zSchema.object({
  companyID: schemes.companyID(),
  contractorPaymentID: schemes.mongoObjectId(),
  deductionID: schemes.mongoObjectId(),
  deduction: zSchema.object({
    employee_contribution: zContributionPatch.optional(),
    employer_contribution: zContributionPatch.optional(),
    additional_fields: zSchema
      .object({
        agency: zSchema
          .object({
            name: zSchema.string().optional(),
            address: zSchema.string().optional(),
          })
          .optional(),
        case_id: zSchema.string().optional(),
        order_number: zSchema.string().optional(),
      })
      .optional(),
  }),
});

export type TPatchContractorPaymentDeductionRequest = zSchema.infer<
  typeof patchContractorPaymentDeductionRequestSchema
>;
